var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-cart",on:{"click":_vm.goToCart}},[_c('img',{attrs:{"src":require("./../../../public/svgs/cart.svg")}}),(_vm.getCartLength)?_c('span',[_vm._v(_vm._s(_vm.getCartLength))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }